import ReactDOM from 'react-dom';
import { FC } from 'react';
import Filings from './containers/Filings';
import FinancialResults from './containers/FinancialResults';
import EventCalendar from './containers/EventCalendar';

const App: FC = () => {
  return (
    <>
      <FinancialResults />
      <Filings />
    </>
  );
};

const eventCalendar = document.getElementById('sw-event-calendar');
if (eventCalendar) {
  ReactDOM.render(<EventCalendar />, eventCalendar);
}

const node = document.getElementById('financials-results');

if (node) {
  ReactDOM.render(<App />, node);
}
